var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L13,3 L13,4 L3,4 L3,3 Z M3,12 L9,12 L9,13 L3,13 L3,12 Z M3,7.5 L13,7.5 L13,8.5 L3,8.5 L3,7.5 Z",
    id: "path-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerAlt);
export default __webpack_public_path__ + "static/media/hamburger-alt.06cfd6b00bd960e9391a74cdb5f3166c.svg";
export { ForwardRef as ReactComponent };